import { render, staticRenderFns } from "./ReadingRestoreDialog.vue?vue&type=template&id=87a436b6&scoped=true"
import script from "./ReadingRestoreDialog.vue?vue&type=script&lang=ts"
export * from "./ReadingRestoreDialog.vue?vue&type=script&lang=ts"
import style0 from "./ReadingRestoreDialog.vue?vue&type=style&index=0&id=87a436b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87a436b6",
  null
  
)

export default component.exports